import { Component, OnInit } from "@angular/core";

import { DefaultEmailService } from "@tylertech/core-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";

@Component({
    selector: "email-test-card",
    templateUrl: "./emailTestCard.tmpl.html",
    standalone: false
})
export class EmailTestCardComponent implements OnInit
{
    loaded: boolean;

    running: boolean;

    metadata: ClassMetadata;

    model: unknown;

    constructor(
        private $defaultEmailService: DefaultEmailService
    ) { }

    ngOnInit(): void
    {
        this.$defaultEmailService.ShowEmailTest()
            .then(x =>
            {
                if (!x) return;
                Promise.all(
                    [
                        this.$defaultEmailService.GetEmailTestMetadata()
                            .then(x =>
                            {
                                this.metadata = x;
                            }),
                        this.$defaultEmailService.GetEmailTestInfo()
                            .then(x =>
                            {
                                this.model = x;
                            })
                    ])
                    .finally(() =>
                    {
                        this.loaded = !!this.metadata;
                    });
            });
    }

    test(): void
    {
        this.running = true;
        this.$defaultEmailService.EmailTest()
            .then(x =>
            {
                this.model = x;
                this.running = false;
            });
    }
}
